<template>
  <div class="">
    <Modal
      v-model="followUpRecListModal"
      width="600"
      :title="followUpRecTitle"
      :mask-closable="false"
      :loading="loading"
      @on-ok="followUpRecList('followUpRecListForm')"
    >
      <Form
        ref="followUpRecListForm"
        :model="followUpRecListForm"
        :rules="ruleValidate"
        :label-width="120"
        label-position="left"
      >
        <FormItem label="跟进节点" prop="content" label-for="content">
          <Select
            placeholder="请选择跟进节点"
            element-id="content"
            v-model="followUpRecListForm.type"
          >
            <Option
              v-for="(item, index) in typeList"
              :key="item.value"
              :value="item.value"
            >
              {{ item.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="跟进记录" prop="content" label-for="content">
          <Input
            placeholder="请输入跟进记录"
            element-id="content"
            v-model="followUpRecListForm.content"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
          ></Input>
        </FormItem>
        <FormItem>
          <UpLoadImg
            ref="uploadImg"
            :multiple="multiple"
            :override="override"
            :show-upload-list="false"
            :num="num"
            :defaultList="imgUrl"
            @on-change-url="followUpRecListForm.img_urls = $event"
          />
        </FormItem>
      </Form>
      <Form v-show="isSHowcloseRemind" :label-width="120" label-position="left">
        <FormItem label="关闭跟进提醒">
          <Checkbox v-model="closeRemind">是</Checkbox>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UpLoadImg from '@/components/UploadImg'
import { followUpType } from '@/assets/globalData'

export default {
  components: {
    UpLoadImg,
  },
  props: {
    agentId: {
      type: Number,
    },
    followUpRecTitle: {
      type: String,
    },
    followUpRecModal: {
      type: Boolean,
      required: true,
    },
    followUpRecRow: {
      type: Object,
    },
  },
  data() {
    const validateNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error('图片不能为空！'))
      } else {
        callback()
      }
    }
    return {
      isSHowcloseRemind: false,
      closeRemind: false,
      loading: true,
      multiple: true,
      num: 6,
      override: true,
      followUpRecListModal: this.followUpRecModal,
      imgUrl: [],

      followUpRecListForm: {
        epId: '',
        content: '',
        type: '',
        img_urls: [],
      },
      ruleValidate: {
        content: [
          { required: true, message: '跟进记录不能为空', trigger: 'blur' },
        ],
        img_urls: [
          { required: true, validator: validateNumber, trigger: 'blur' },
        ],
      },
      typeList: followUpType,
    }
  },
  methods: {
    // 保存编辑数据
    followUpRecList(val) {
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 50)
      this.$refs[val].validate(async (valid) => {
        if (valid) {
          let data = {
            ...this.followUpRecListForm,
          }
          let url = '/enterprise/followup'
          let res = await this.$http.post(url, data)
          if (res.success) {
            if (this.isSHowcloseRemind && this.closeRemind) {
              await this.$http.post('/enterprise/followupremind/save', {
                epId: this.followUpRecListForm.epId,
                remind_type: 0,
                remind_time: '',
              })
            }
            this.$Message.success('新增成功')
            this.followUpRecListModal = false
            this.$emit('callback')
          } else {
            this.$Message.error(res.message)
          }
        }
      })
    },
    reload() {
      this.agentId = this.followUpRecRow.id
      this.followUpRecListForm.epId = this.followUpRecRow.id

      this.$http
        .get('/enterprise/followupremind/find', {
          params: {
            epId: this.followUpRecRow.id
              ? this.followUpRecRow.id
              : this.followUpRecRow.fk_t_enterprise_id,
          },
        })
        .then((res) => {
          if (res.data) {
            this.isSHowcloseRemind = res.data.remind_type === 1
          }
        })
    },
  },
  watch: {
    followUpRecModal(val) {
      this.followUpRecListModal = val
      if (val) {
        this.reload()
      } else {
        this.followUpRecListForm = {
          epId: '',
          content: '',
          type: '',
          img_urls: [],
        }
      }
    },
    followUpRecListModal(val) {
      if (!val) {
        this.$emit('backeditModal')
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/NewFollowUpRecords.vue